const React = require("react");

function PresentationChartLineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
  }));
}

module.exports = PresentationChartLineIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/PresentationChartLineIcon.js
 ** module id = 589
 ** module chunks = 0
 **/